const LIGHT = '/favicon-light.png';
const DARK = '/favicon-dark.png';

function applyFavicon(dark: boolean) {
  const href = dark ? DARK : LIGHT;
  let link = document.querySelector<HTMLLinkElement>('link[data-app-icon="default"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.setAttribute('data-app-icon', 'default');
    document.head.appendChild(link);
  }
  if (link.href.endsWith(href)) return;
  link.href = href;
}

/** Tab icon follows OS light/dark (also updates when the user toggles system theme). */
export function initFavicon() {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  applyFavicon(mq.matches);
  mq.addEventListener('change', (e) => applyFavicon(e.matches));
}
